import React, { useState, Dispatch, SetStateAction } from "react";
import { T } from "services/lang/LanguageService";
import { Dashboard } from "api/model/dashboard/Dashboard";
import { Input } from "../InputCategories";

const GeneralSubForm = (props: {
  dashboard: Dashboard;
  setNewGeneralSub: Dispatch<SetStateAction<object>>;
}) => {
  const [title, setTitle] = useState<string>(props.dashboard.title);
  const [companyShared, setCompanyShared] = useState<boolean>(
    props.dashboard.companyShared
  );
  const onGeneralInputChange = (key: keyof Dashboard, value: any) => {
    if (key === "title") {
      setTitle(value);
    } else if (key === "companyShared") {
      setCompanyShared(value);
    }
    props.setNewGeneralSub((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  return (
    <React.Fragment>
      <h5 className="mb-5">{T("word.general")}</h5>
      <div className="grid">
        <span className="p-float-label col-12 md:col-5">
          <Input.Text
            id="input-dashboard-title"
            label={T("word.title")}
            property={"title"}
            sourceObj={{ title }}
            onChange={onGeneralInputChange}
          />
        </span>

        <span className="p-float-label col-12 md:col-5">
          <Input.Text
            id="input-dashboard-icon-class"
            label={T("word.icon-class")}
            property={"iconClass"}
            sourceObj={ props.dashboard }
            onChange={onGeneralInputChange}
            editable={true} //disabled
          />
        </span>

        <span className="col-12 md:col-2">
          <Input.Boolean
            id="input-dashboard-company-shared"
            label={T("word.company-shared")}
            property={"companyShared"}
            sourceObj={{ companyShared }}
            onChange={onGeneralInputChange}
          />
        </span>
      </div>
    </React.Fragment>
  );
};

export default GeneralSubForm;
